<template>
    
    <b-container
    class="mt-2"
    style="border: 2px solid #10486A; border-radius: 5px; background-color:#FFFFFF">

    <b-row cols="1" cols-md="2" cols-lg="4">

        <b-col style="border:#000000 solid 1px;" cols-md="2">1</b-col>
        <b-col style="border:#000000 solid 1px;" cols-md="2">2</b-col>
        <b-col style="border:#000000 solid 1px;" cols-md="2">3</b-col>
        <b-col style="border:#000000 solid 1px;" cols-md="2">4</b-col>
        <b-col style="border:#000000 solid 1px;" cols-md="2">5</b-col>
        <b-col style="border:#000000 solid 1px;" cols-md="2">6</b-col>
        <b-col style="border:#000000 solid 1px;" cols-md="2">7</b-col>
        <b-col style="border:#000000 solid 1px;" cols-md="2">8</b-col>

    </b-row>

    </b-container>

</template>

<script>
export default {
    
}
</script>

<style>

</style>